<script lang="ts">
  import { is_typing, mode, selected_game, WebSocket } from "./stores";
  import Connect4 from "./Connect4/Connect4.svelte";
  import Filler from "./Filler/Filler.svelte";
  import Menu from "./Menu.svelte";
import Wordle from "./Wordle/Wordle.svelte";

  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.has("g")) {
    selected_game.set(urlParams.get("g"));
  }

  if ($mode === "dark") {
    window.document.body.classList.toggle("dark-mode");
  }

  function toggle() {
    if ($mode === "light") {
      mode.set("dark");
    } else {
      mode.set("light");
    }

    window.document.body.classList.toggle("dark-mode");
  }


  let keypress_listener: any = (e: { key: any; }) => {
    if(!($selected_game === "Wordle") || $is_typing) return;
    $WebSocket.emit("Turn", {letter:e.key})
  };
  let keydown_listener: any = ({key}) => {
      if(!($selected_game === "Wordle") || $is_typing) return;
      switch (key){
        case "Backspace":
        case "Delete":
          $WebSocket.emit("Turn", {remove: true})
          break;
        case "Enter":
          $WebSocket.emit("Turn", {submit: true})
          break;
      }
    };
    document.onkeypress = keypress_listener;
    document.onkeydown = keydown_listener;
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://use.fontawesome.com/releases/v5.15.3/css/all.css"
  />
</svelte:head>

<main>
  <body>
    <i
      class={`toggle fas ${$mode === "dark" ? "fa-sun" : "fa-moon"}`}
      on:click={toggle}
    />
    {#if $selected_game === "Connect4"}
      <Connect4 />
    {:else if $selected_game === "Filler"}
      <Filler />
    {:else if $selected_game === "Wordle"}
    <Wordle />
    {:else}
      <Menu />
    {/if}
  </body>
</main>

<style>
  .toggle {
    position: absolute;
    right: 1rem;
    top: 1rem;
    transition: 200ms;
    font-size: 1.5rem;
    cursor: pointer;
  }

  .toggle:hover {
    color: var(--text-color-hover);
  }

  .toggle:active {
    color: var(--text-color-active);
  }

  :global(body.dark-mode) {
    --bg-color: var(--offblack);

    --text-color: var(--textwhite);
    --text-color-secondary: var(--textsecondaryblack);

    --text-color-disabled: var(--textblackdisabled);
    --text-color-active: var(--textblackactive);
    --text-color-hover: var(--textblackhover);

    --accent-color: var(--accentblack);

    --accent-color-disabled: var(--accentblackdisabled);
    --accent-color-active: var(--accentblackactive);
    --accent-color-hover: var(--accentblackhover);
    --accent-color-shadow: var(--accentblackshadow);
    --accent-color-trans: var(--accentblacktrans);

    --special-color: var(--blackspecialcolor);
    --special-color-hover: var(--blackspecialcolorhover);
    --special-color-active: var(--blackspecialcoloractive);
    --special-color-disabled: var(--blackspecialcolordisabled);
    --special-color-lip: var(--blackspecialcolorlip);
  }
</style>
